import Form from "semantic-ui-react/dist/es/collections/Form/Form.js";
export var Component = Form.Group;
Component.displayName = 'InputGroup';